import { render, staticRenderFns } from "./SavedMessage.vue?vue&type=template&id=21f8cc84&scoped=true"
import script from "./SavedMessage.vue?vue&type=script&lang=js"
export * from "./SavedMessage.vue?vue&type=script&lang=js"
import style0 from "./SavedMessage.vue?vue&type=style&index=0&id=21f8cc84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f8cc84",
  null
  
)

export default component.exports